import { Component } from '@angular/core';
import { ArticlesService } from '../../services/articles.service';
import { Reset } from '../../models/reset.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password-parent',
  templateUrl: 'reset-password-parent.html',
  styleUrls: ['reset-password-parent.scss']
})
export class ResetPasswordParentPage {
  public model = new Reset('', '');
  public validToken: boolean;

  constructor(private router: Router, private service: ArticlesService ) { }

  ionViewDidLoad() {
    this.checkToken();
  }

  getToken(): string {
    const slug = document.location.pathname;
    const segments = slug.split('/');
    const lastSegment = segments.length - 1;
    return segments[lastSegment];
  }

  checkToken() {
    const token = this.getToken();
    this.service.isTokenValidParent(token).subscribe(
      () => this.validToken = true,
      () => this.validToken = false
    );
  }

  onSubmit(formValues: any, event: Event) {
    event.preventDefault();
    const token = this.getToken();
    const resetObj = { token, password: formValues.password1 };
    this.service.resetParentPass(resetObj).subscribe(
      () => this.router.navigate(['connexion']),
      () => {}
    );
  }
}
